import React from "react"

type ConfirmModalProps = {
  open: boolean
  title?: string
  message?: string
  confirmText?: string
  cancelText?: string
  onConfirm: () => void
  onCancel: () => void
  variant?: "danger" | "primary" | "success"
  children?: React.ReactNode
}

const VARIANT_STYLES: Record<string, string> = {
  danger: "bg-red-600 hover:bg-red-700",
  primary: "bg-blue-600 hover:bg-blue-700",
  success: "bg-green-600 hover:bg-green-700",
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  title = "Are you sure?",
  message = "This action cannot be undone.",
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  variant = "primary",
  children,
}) => {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-lg dark:bg-slate-800">
        {/* Header */}
        <h3 className="mb-2 text-lg font-semibold text-gray-900 dark:text-white">
          {title}
        </h3>

        {/* Body */}
        {children ? (
          <div className="mb-4 text-sm text-gray-600 dark:text-gray-300">
            {children}
          </div>
        ) : (
          <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">
            {message}
          </p>
        )}

        {/* Footer */}
        <div className="flex justify-end gap-3">
          <button
            onClick={onCancel}
            className="rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-800 hover:bg-gray-300 dark:bg-slate-700 dark:text-gray-200 dark:hover:bg-slate-600"
          >
            {cancelText}
          </button>

          <button
            onClick={onConfirm}
            className={`rounded-lg px-4 py-2 text-sm font-medium text-white ${VARIANT_STYLES[variant]}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}
